import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { uniqBy, get, size } from 'global/lib/lodash';
import useRetrieveData from 'global/hooks/useRetrieveData';

export const useSupersets = (props) => {
  const { assessment } = props;
  // PFM-2547: /sharehash/v1/supersets is not exposed by the backend (404), so
  // skip both fetches in a hashed share-link session. Callers fall back to the
  // supersets included on the photos themselves (see ReportAssessmentPhotos).
  const hashViewHasToken = useSelector((s) => !!s?.hashAuth?.hashToken);

  const [state, setState] = useState({
    supersets: [],
  });

  const { data } = useRetrieveData(
    { url: '/supersets' },
    {
      build: ['supersets'],
      useCache: { reload: 20 },
      waitFor: hashViewHasToken ? null : !!assessment ? undefined : null,
    }
  );

  const scards = get(assessment, 'scorecards');
  const scorecardids = (scards || []).map((sc) => sc.id);
  const hasScorecards = !!size(scorecardids);

  const getData = () => {
    if (hashViewHasToken) {
      setState((s) => ({ ...s, supersets: [] }));
      return;
    }

    const wanted = new Set(scorecardids.map((id) => String(id)));
    const scorecardIdsFor = (ss) => get(ss, 'scorecardIds', get(ss, 'scorecard_ids', []));
    let res = data || [];
    if (hasScorecards && res.some((ss) => size(scorecardIdsFor(ss)))) {
      res = res.filter((ss) => (scorecardIdsFor(ss) || []).some((id) => wanted.has(String(id))));
    }

    setState((s) => ({
      ...s,
      supersets: uniqBy(
        res.filter((f) => f),
        'id'
      ).map((ss) => ({ ...ss, id: ss.id.toString() })),
    }));
  };

  useEffect(() => {
    getData();
  }, [scards, hashViewHasToken, data]);

  return state;
};
